module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Audits px-4"
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "480",
      "persistent": ""
    },
    model: {
      value: (_vm.fieldSurveyPendingDialog),
      callback: function($$v) {
        _vm.fieldSurveyPendingDialog = $$v
      },
      expression: "fieldSurveyPendingDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('FieldSurveyPending.title')))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.$t('FieldSurveyPending.message')))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "text-none",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.onFieldSurveyPendingLater
    }
  }, [_vm._v(_vm._s(_vm.$t('FieldSurveyPending.completeLater')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-none",
    attrs: {
      "color": "#0098E1",
      "dark": ""
    },
    on: {
      "click": _vm.onFieldSurveyPendingGoToSetup
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('FieldSurveyPending.goToSetup')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "top": "",
      "color": _vm.snackbar.color,
      "rounded": "",
      "centered": ""
    },
    model: {
      value: (_vm.snackbar.show),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "show", $$v)
      },
      expression: "snackbar.show"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.text) + "\n  ")]), _vm._v(" "), _c('v-container', [_c('Header', {
    attrs: {
      "auditDealsDates": _vm.combinedAuditDealsDates,
      "orgInfo": _vm.organizationData.orgInfo,
      "loadingQuery": _vm.$apollo.queries.organizationData.loading,
      "preferredDealKey": _vm.preferredDealKey,
      "loadingDeals": !_vm.dealsReady
    },
    on: {
      "changeAuditDeal": _vm.changeAuditDealHandler
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.showAuditsMainLoading) ? _c('div', {
    staticClass: "display-1 text-center mt-5"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "#0098E1"
    }
  })], 1) : (_vm.isDesktopView) ? [(!_vm.dealsReady) ? _c('v-container', {
    staticClass: "display-1 text-center mt-5",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "#0098E1"
    }
  })], 1) : (_vm.$apollo.queries.organizationData.loading) ? _c('v-container', {
    staticClass: "display-1 text-center mt-5",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "#0098E1"
    }
  })], 1) : (_vm.combinedAuditDealsDates.length === 0) ? _c('v-container', {
    staticClass: "display-1 text-center grey--text",
    attrs: {
      "fluid": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("Audits.noAudits")) + "\n      ")]) : (_vm.auditDealId) ? [(_vm.shouldShowFieldSurveySetupCTA) ? _c('section', {
    staticClass: "audits-fs-setup-banner",
    attrs: {
      "role": "status"
    }
  }, [_c('div', {
    staticClass: "audits-fs-setup-banner-content"
  }, [_c('span', {
    staticClass: "audits-fs-setup-banner-text"
  }, [_vm._v(_vm._s(_vm.$t('Audits.fieldSurveySetupRequired')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "audits-fs-setup-banner-action",
    attrs: {
      "color": "#0098E1",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": _vm.goToSelectedFieldSurveySetup
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('Audits.goToFieldSurveySetup')) + "\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showInnerEmptyStateLoading) ? _c('v-container', {
    staticClass: "display-1 text-center mt-5",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "#0098E1"
    }
  })], 1) : (!_vm.hasCardsToDisplay) ? _c('v-container', {
    staticClass: "display-1 text-center grey--text",
    attrs: {
      "fluid": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Audits.noAudits")) + "\n        ")]) : [(_vm.showAdminEditServiceLink) ? _c('div', {
    staticClass: "audits-fs-edit-service-wrap"
  }, [_c('a', {
    staticClass: "audits-fs-edit-service-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToSelectedFieldSurveySetup.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('FieldSurveyForm.editService')) + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeKeystoneDevices), function(device) {
    return _c('MainCard', {
      key: ("ks-" + (device.id)),
      attrs: {
        "id": ((device.id) + "-main-card"),
        "deviceData": device,
        "auditData": _vm.auditsData.find(function (audit) { return audit.device.id === device.id; }),
        "flowMeasurementData": _vm.flowMeasurementsData.find(function (flowMeasurement) { return flowMeasurement.device.id === device.id; }),
        "pluviometricChartData": _vm.pluviometricChartsData.find(function (pluviometricChart) { return pluviometricChart.device.id === device.id; }),
        "uniformityData": _vm.uniformitiesData.find(function (uniformity) { return uniformity.device.id === device.id; })
      }
    })
  }), _vm._v(" "), _vm._l((_vm.visibleFieldSurveyEquipments), function(equipment) {
    return _c('FieldSurveyStatusCard', {
      key: ("fs-" + (equipment.id)),
      attrs: {
        "equipment": equipment
      }
    })
  })]] : _vm._e()] : _c('v-container', {
    staticClass: "text-center mt-5 pa-5",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-icon', {
    staticClass: "mb-4",
    attrs: {
      "size": "45",
      "color": "#00202F"
    }
  }, [_vm._v("mdi-monitor")]), _vm._v(" "), _c('p', {
    staticClass: "mobile-title-text mb-2"
  }, [_vm._v("No disponible en móvil")]), _vm._v(" "), _c('p', {
    staticClass: "mobile-subtitle-text"
  }, [_vm._v("Debe acceder desde una computadora para ver este informe correctamente. La versión móvil estará disponible pronto.")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5307144","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audits/Audits.vue
// module id = 1756
// module chunks = 0